import { render } from "./LOHeader.vue?vue&type=template&id=156a4b2a"
import script from "./LOHeader.vue?vue&type=script&lang=js"
export * from "./LOHeader.vue?vue&type=script&lang=js"

import "./LOHeader.vue?vue&type=style&index=0&id=156a4b2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__